import { Model } from "@vuex-orm/core";
import Customer from "./Customer";

export default class OtherInfo extends Model {
  static entity = "otherInfos";

  static fields() {
    return {
      createdAt: this.attr(),
      updatedAt: this.attr(),
      id: this.attr(),
      isDirty: this.boolean(false),
      customerId: this.number(0),
      label: this.attr(),
      listItemId: this.number(),
      detail: this.attr(),
      customer: this.belongsTo(Customer, "customerId")
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
